;(function() {
  'use strict'

  controller.$inject = ["$transitions", "$scope", "$timeout"];
  angular.module('core.pageSelector').controller('PageSelector', controller)

  /* @ngInject */
  function controller($transitions, $scope, $timeout) {
    // close dialog if route changes
    $transitions.onStart(null, closeDialog)

    function closeDialog() {
      // https://engagementinnovation.atlassian.net/browse/GLOWSYSLIB-134
      // requires this to be wrapped in unncessary function,
      // this can be called directly from the listeners etc once resolved
      $timeout(function() {
        $scope.dialog.close()
      }, 100)
    }
  }
})()
